import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

// Define the bounce animation
const bounce = keyframes`
  0%, 80%, 100% { 
    transform: translateY(0);
  }
  40% { 
    transform: translateY(-5px);
  }
`;

// TypingIndicator component
const TypingIndicator = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.6,
        p: 1,
        pl: 2,
      }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 12, // Adjusted size
            height: 12, // Adjusted size
            borderRadius: '23px',
            backgroundColor: 'primary.main', // Match theme color

            animation: `${bounce} 1.2s infinite`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Box>
  );
};

export default TypingIndicator;
